import { makeStyles } from "@mui/styles";
import { APP_COLORS } from "../../../enums";

export const useRadioOptionSelectionStyles = makeStyles({
  option: {
    margin: 0,
    padding: "10px 12px",
    width: "100%",
    borderRadius: 12,
    border: `1px solid ${APP_COLORS.greyLight3}`,
    backgroundColor: APP_COLORS.white,
    transition: "border-color 0.2s, background-color 0.2s",
    "&:hover": {
      backgroundColor: APP_COLORS.greyLight,
    },
  },
  optionSelected: {
    borderColor: APP_COLORS.primary,
    backgroundColor: APP_COLORS.primaryLight,
    "&:hover": {
      backgroundColor: APP_COLORS.primaryLight,
    },
  },
  otherField: {
    backgroundColor: APP_COLORS.white,
    "& .MuiOutlinedInput-root": {
      borderRadius: 16,
      "&:hover fieldset": {
        borderColor: APP_COLORS.secondary,
      },
      "&.Mui-focused fieldset": {
        borderWidth: 2,
        borderColor: APP_COLORS.secondary,
      },
    },
  },
});
